import React, { useRef, useMemo, useEffect } from "react"
import { useNavigate } from "react-router"
import { Button, DatePicker, Form, Input, Upload, Select } from "antd"
import { useDispatch, useSelector } from "react-redux"

// Components
import showSecondarySidebar from "../../../../layout/MainLayout/helpers/showSecondarySidebar"
import Page from "../../../../components/Decoration/Page"

// Handlers
import { uploadHDLR } from "../../../../handlers"

// Services Library
import { TIME, REDUX } from "../../../../services/util"

// Redux Actions
import * as REDUX_ACTIONS from '../../../../services/redux/actions'

// Style
import styles from './index.module.css'

const { getBase64, handleBeforeUpload, UploadDriverICImage, DeleteImage } = uploadHDLR;

const DriverAdd = ({
    data = {}
}) => {

    const title = data.title || 'Add New'

    const dispatch = useDispatch()
    const navigate = useNavigate()

    const [ form ] = Form.useForm()

    const user = useSelector(REDUX.reduxStoreWrapper('user'))

    const { uid } = user

    const onFinish = (e) => {

        const rec = {...e}
        delete rec.key

        const items = {
            driver: {
                ...rec,
                refid: e.refid || '',
                icSerialNumber: e.icSerialNumber || '',   
                licenseExpiredAt: TIME.parseTimestamp(e.licenseExpiredAt) || 0,
                ic: icref.current
            },
            uid: uid,
            drvid: data.drvid
        }

        switch(title) {
            case 'Add New': {
                dispatch(REDUX_ACTIONS.v3_drivers.create_driver_request(items, () => {
                    navigate(`/management/driver`)
                }))

                break;
            }
            case 'Edit': {
                dispatch(REDUX_ACTIONS.v3_drivers.update_driver_request(items, () => {
                    navigate(`/management/driver`)
                }))

                break;
            }
        }
    }

    // upload image
    const icref = useRef([])
    
    const handleChange = (info) => {
        const { status, originFileObj, response = {} } = info.file;

        if(status === "done") {
            getBase64(originFileObj, () => {
                const { url } = response;

                icref.current = [ ...icref.current, url ]
                // form.setFieldsValue({ ic: icref.current })

            });
        }
    };

    const handleRemoveAttachment = (file) => {
        const { url } = file.response

        DeleteImage(file)
        icref.current = icref.current.filter(ic => ic !== url)
    }

    const newFileList = useMemo(() =>
        (data?.ic || []).map((ic, index) => {
            return {
                uid: `${index}`,
                name: ic.split('/').pop(),
                status: 'done',
                url:ic,
            };
    }).filter(Boolean), [data?.ic]);

    
    useEffect(() => {
        form.setFieldsValue({ company: (data.company && (data.company !== '-')) ? data.company : uid })
    }, [uid])

    return (
        <div className="page-container">
            <Page title={`${title} Driver`}>
                <Form 
                    style={{ width: '50vw', minWidth: '60em', margin: '5em auto'}}
                    labelCol={{ span: 4 }}
                    form={form}
                    onFinish={onFinish}
                    initialValues={{
                        ...data,
                        rfid: data.icSerialNumber ? true : false,
                        licenseExpiredAt: TIME.dayJS(data?.licenseExpiredAt),
                        company: data.company || uid
                    }}
                >
                    <Form.Item
                        label="Company Name"
                        name="company"
                        // rules={[
                        //     {
                        //         required: true,
                        //         message: 'Please select company name!',
                        //     },
                        // ]}
                        >
                            <Select options={[user].map(u => ({ label: u.name, value: u.uid }))} disabled/>
                    </Form.Item>
                    <Form.Item
                        label="Driver Name"
                        name="name"
                        rules={[
                            {
                                required: true,
                                message: 'Please input driver name!',
                            },
                        ]}
                        >
                            <Input size="large" />
                    </Form.Item>
                    <Form.Item
                        label="Driver Contact"
                        name="contact"
                        rules={[
                            {
                                required: true,
                                message: 'Please input driver contact!',
                            },
                            {
                                pattern: /^(?:\+60|60|0)(?:1[0-46-9][0-9]{7,8}|[3-9][0-9]{7,8})$/,
                                message: 'Invalid phone number format. Please enter a valid phone number!'

                            }
                        ]}
                        >
                            <Input size="large" placeholder="60123456789"/>
                        </Form.Item>
                    <Form.Item
                        label="IC Number"
                        name="icNumber"
                        rules={[
                            {
                                required: true,
                                message: 'Please input IC number!',
                            },
                            {
                                pattern: /^\d+$/,
                                message: 'Please input only number'
                            },
                            {
                                pattern: /^[0-9]{12}$/,
                                message: 'Invalid IC number. Must be a 12-digit IC number'

                            }
                        ]}
                        >
                            <Input size="large" />
                        </Form.Item>
                    <Form.Item
                        label="License Expiry"
                        name="licenseExpiredAt"
                        rules={[
                            {
                                required: true,
                                message: 'Please input expiry date!',
                            },
                        ]}
                        >
                            <DatePicker
                                size='large'
                                style={{ width: '100%'}}
                                // showTime={{ format: 'HH:mm' }}
                                format="YYYY-MM-DD"
                            />
                        </Form.Item>
                        <Form.Item
                        label="IC Attachment"
                        name="ic"
                        // rules={[
                        //     {
                        //         required: true,
                        //         message: 'Please input driver reference id!',
                        //     },
                        // ]}
                        >
                            <Upload
                                listType="picture-card"
                                customRequest={UploadDriverICImage}
                                beforeUpload={handleBeforeUpload}
                                onChange={handleChange}
                                onRemove={handleRemoveAttachment}
                                defaultFileList={newFileList}
                            >
                                + Upload
                            </Upload>
                        </Form.Item>
                        <Form.Item
                        label="Reference ID"
                        name="refid"
                        // rules={[
                        //     {
                        //         required: true,
                        //         message: 'Please input driver reference id!',
                        //     },
                        // ]}
                        >
                            <Input size="large" />
                        </Form.Item>
                        {/* <div style={{ margin: '2em 0'}}>
                            <Typography.Text type="secondary">DEVICE INFORMATION.</Typography.Text>
                        </div> */}
                        {/* <Form.Item
                            label="RFID Reader"
                            name="rfid"
                            rules={[
                                {
                                    required: true,
                                },
                            ]}
                        >
                            <Switch value={isRfid} onChange={e => setIsRfid(e) } /> 
                        </Form.Item> */}
                        {/* {
                            isRfid
                            && */}
                            <Form.Item
                                label="IC Serial Number"
                                name="icSerialNumber"
                                // rules={[
                                    // {
                                    //     required: true,
                                    //     message: 'Please input driver reference id!',
                                    // },
                                    // {
                                    //     pattern: /^[a-zA-Z0-9]{8}$/,
                                    //     message: 'Please input 8-length number'
                                    // }
                                // ]}

                            >
                                <Input size="large" />
                            </Form.Item>
                        {/* } */}
                        <div className={styles['button-container']}>
                            <Button className={`${styles['button']} ${styles['cancel']}`} onClick={() => navigate(-1)}>Cancel</Button>
                            <Button className={`${styles['button']} ${styles['add']}`} htmlType="submit">{title === 'Add New' ? 'Add' : 'Save'}</Button>
                        </div>
                </Form>
            </Page>
        </div>
    )
}

const MemoizedDriverAdd = React.memo(DriverAdd);

export default showSecondarySidebar(false)(MemoizedDriverAdd);